export const KRENT_MEDIA_VIDEO_SRC = "/videos/2026ad.mp4";
export const STANDARD_PACKAGE_VIDEO_SRC = "/videos/standard.mp4";
export const PREMIUM_PACKAGE_VIDEO_SRC = "/videos/premium.mp4";
